// Deprecated, use src/util/format/string-format.js
const capitalize = (string) => string.charAt(0).toUpperCase() + string.slice(1)

export default {
    capitalize,
}
